'use client';

import { DialogFooter, DrawerFooter, Button, LoadingSpinner } from '@shared/ui';
import { useMobile } from '@shared/hooks';
import { useOtpContext } from '../model';

interface OtpFooterProps {
  children?: React.ReactNode;
  className?: string;
}

export const OtpFooter: React.FC<OtpFooterProps> = ({ children, className = '' }) => {
  const { timer, resend, resendButtonRef } = useOtpContext();
  const isMobile = useMobile();

  const footerContent = (
    <div
      className={`w-full rounded-bl-xl rounded-br-xl border-t border-border flex justify-center items-center gap-5 p-5 h-[71px] body-12-regular text-disableText ${className}`}
    >
      {children ? (
        children
      ) : timer > 0 ? (
        <div>
          ارسال مجدد کد بعد از{' '}
          {Math.floor(timer / 60)
            .toString()
            .padStart(2, '0')}
          :{(timer % 60).toString().padStart(2, '0')}
        </div>
      ) : (
        <div className='flex items-center gap-2 justify-center'>
          <Button
            ref={resendButtonRef}
            variant='link'
            className='text-blue-1 body-12-bold px-0'
            onClick={resend.action}
            disabled={resend.isPending}
          >
            ارسال مجدد کد
            {resend.isPending && <LoadingSpinner className='text-pics scale-[0.6]' />}
          </Button>
        </div>
      )}
    </div>
  );

  return isMobile ? (
    <DrawerFooter className='px-0 pb-0'>{footerContent}</DrawerFooter>
  ) : (
    <DialogFooter>{footerContent}</DialogFooter>
  );
};
